import { ShipTo } from './orderHeaderDropdowns';
import { OrderList } from './orderList';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';

export interface Customer {
  name?: string;
  number?: number;
  numberString?: string;
  avatarPath?: string;
  carrier?: string;
  warehouseCode?: string;
  backupWarehouseCode?: string;
  warehouseName?: string;
  backupWarehouseName?: string;
  hardGoodsRep?: string;
  hardGoodsRepCode?: string;
  plantRep?: string;
  plantRepCode?: string;
  defaultShipTo?: string;
  defaultShipToTermCode?: string;
  lawnGardenRep?: string;
  lawnGardenRepCode?: string;
  carrRep?: string;
  city?: string;
  state?: string;
  carrRepCode?: string;
  openOrders?: OrderList;
  unsubmittedOrders?: OrderList;
  poRequired: boolean;
  defaultTermCode?: string;
  creditManager?: string;
  creditLimit?: number;
  agingCurrent?: number;
  aging1_30?: number;
  aging31_60?: number;
  aging61_90?: number;
  agingOver90?: number;
  lastPaymentDate?: string;
  averageDaysToPay?: number;
  pastDueDays?: number;
  futureDue?: number;
  availableCredit?: number;
  serviceCharges?: number;
  miscCredits?: number;
  unappliedCash?: number;
  salesOrderStatus?: string;
  email?: string;
  customerPhoneNumber?: string;
  customerType?: string;

  //customer's ship to, selected in customer menu and used for pricing call
  selectedShipToNumber?: string;
  //warehouse assocatied with selected ship to in customer menu
  selectedShipToWarehouse?: string;
  //Default term code for selected ship to
  selectedShipToTermCode?: string;

  shipTos: CustomerShipTo[];

  // Saved filters for open orders grid
  openOrderFilters?: CompositeFilterDescriptor[];
}

export interface CustomerShipTo extends ShipTo {
  shipNo: string;
  shipToName: string;
  shipToAddress1: string;
  shipToAddress2?: string;
  shipToCity: string;
  shipToState: string;
  shipToZip: string;
  backupWarehouseCode: string;
  backupWarehouseName: string;
  carrier: string;
  custNo: string;
  customerPhoneNumber: string;
  description: string;
  hardGoodsRep: string;
  lawnGardenRep: string;
  minOrderAmount: string;
  overMinCharge: string;
  plantRep: string;
  route: string;
  termCode: string;
  underMinCharge: string;
  warehouseCode: string;
  warehouseName: string;
}

export interface CustomerReps {
  hardGoodsRep?: string;
  lawnGardenRep?: string;
  plantRep?: string;
}

export function isCustomer(arg: any): arg is Customer {
  return arg && arg.number;
}

export const getShipToForNewOrders = (customer: Customer): string | null => {
  return customer.selectedShipToNumber && customer.selectedShipToNumber.trim().length > 0 ? customer.selectedShipToNumber : customer.defaultShipTo;
};

export const getWarehouseCodeForNewOrders = (customer: Customer): string | null => {
  return customer.selectedShipToWarehouse && customer.selectedShipToWarehouse.trim().length > 0 ? customer.selectedShipToWarehouse : customer.warehouseCode;
};

export const getWarehouseCodeForNewOrdersGranular = (selectedShipToWarehouse: string | undefined, warehouseCode: string | undefined): string | null => {
  return selectedShipToWarehouse && selectedShipToWarehouse.trim().length > 0 ? selectedShipToWarehouse : warehouseCode || null;
};

export const getShipToForNewOrdersGranular = (selectedShipToNumber: string | undefined, defaultShipTo: string | undefined): string | null => {
  return selectedShipToNumber && selectedShipToNumber.trim().length > 0 ? selectedShipToNumber : defaultShipTo || null;
};
